import { vPopper, UiPopper } from '@omnica/popper-vue3';
import { defineComponent, h, normalizeClass, openBlock, createElementBlock, createElementVNode, ref, watch, onBeforeUnmount, createCommentVNode, renderSlot, createVNode, unref, mergeProps, withCtx, normalizeStyle } from 'vue';
import { PLACEMENT } from '@omnica/popper';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const arraify$1 = (value) => Array.isArray(value)
    ? [...value]
    : [value];
const render$1 = (content) => arraify$1(typeof content === 'function'
    ? content(h)
    : content);

var script$1 = defineComponent({
    name: 'OmnicaVNodeContent',
    props: {
        /** Контент для отрисовки */
        content: {
            type: null,
            validator: () => true,
            required: true,
        },
    },
    setup: props => () => render$1(props.content),
});

script$1.__file = "packages/scaffolding/src/OmnicaVNodeContent.vue";

const arraify = (value) => Array.isArray(value)
    ? [...value]
    : [value];
const normalizeOptions = (optionsOrContent) => {
    if (optionsOrContent === null) {
        return null;
    }
    const normalized = typeof optionsOrContent === 'object'
        ? optionsOrContent
        : { content: optionsOrContent };
    const { classes, centered, content, inline, large, style } = normalized, options = __rest(normalized, ["classes", "centered", "content", "inline", "large", "style"]);
    if (!content) {
        return null;
    }
    return Object.assign({ class: normalizeClass([{
                'omnica-tooltip__popper': true,
                'omnica-tooltip__popper_centered': centered,
                'omnica-tooltip__popper_inline': inline,
                'omnica-tooltip__popper_large': large,
            }, ...arraify(classes !== null && classes !== void 0 ? classes : {})]), content: () => h('div', { class: 'omnica-tooltip__content', style }, render$1(content)), dark: true, delay: { show: 200, hide: 0 }, triggers: ['hover', 'focus', 'touch'] }, options);
};
const normalizeBinding = (binding) => {
    return Object.assign(Object.assign({}, binding), { value: normalizeOptions(binding.value), oldValue: normalizeOptions(binding.oldValue) });
};
var vTooltip = {
    beforeMount: (el, binding, node, prevVNode) => {
        vPopper.beforeMount(el, normalizeBinding(binding), node, prevVNode);
    },
    updated: (el, binding, node, prevVNode) => {
        vPopper.updated(el, normalizeBinding(binding), node, prevVNode);
    },
    beforeUnmount: vPopper.beforeUnmount,
};

const _hoisted_1$1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1 = /*#__PURE__*/createElementVNode("path", {
  d: "M4 12a8 8 0 1116 0 8 8 0 01-16 0zm11 2.045c0-.122-.05-.24-.14-.324L13.148 12l1.712-1.721a.445.445 0 000-.648l-.49-.49a.444.444 0 00-.649 0L12 10.851 10.279 9.14a.444.444 0 00-.648 0l-.49.49a.444.444 0 000 .649L10.851 12 9.14 13.721a.444.444 0 000 .648l.49.49a.444.444 0 00.649 0L12 13.149l1.721 1.712a.444.444 0 00.648 0l.49-.49a.445.445 0 00.141-.325z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1 = [
  _hoisted_2$1
];

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1, _hoisted_3$1))
}

const _hoisted_1 = { class: "omnica-tooltip" };
const _hoisted_2 = {
    key: 1,
    class: "omnica-tooltip__steps"
};
const _hoisted_3 = {
    key: 3,
    class: "omnica-tooltip__footer"
};
var script = /*#__PURE__*/ defineComponent({
    __name: 'UiTooltip',
    props: {
        /** Управлению видимостью контента подсказки вручную. Может использоваться с директивой v-model */
        opened: {
            type: Boolean,
            default: false,
        },
        /** События, при которых показывается тултип. Например, 'hover focus' */
        trigger: {
            type: String,
            default: 'hover',
        },
        /** Позиционирование всплывающей подсказки */
        placement: {
            type: String,
            validator: (position) => Object.values(PLACEMENT).includes(position),
            default: PLACEMENT.BOTTOM,
        },
        /** Добавляет иконку закрытия к контенту подсказки и возможность закрыть её вручную */
        closable: {
            type: Boolean,
            default: false,
        },
        /** Центрирование текста для простого контента */
        centered: {
            type: Boolean,
            default: false,
        },
        /** Применяет к всплывающей подсказке темную тему */
        dark: {
            type: Boolean,
            default: false,
        },
        /** Изменение размера контента */
        large: {
            type: Boolean,
            default: false,
        },
        /**
         * Определяет наличие указателя.
         * Применяется по-умолчанию, если флаг closable выставлен в true.
         */
        withPointer: {
            type: Boolean,
            default: false,
        },
        /** Время в ms, через которое подсказка автоматически скроется */
        hideTime: {
            type: [Number, String],
            default: 0,
        },
        /** Однострочная, простая всплывающая подсказка */
        inline: {
            type: Boolean,
            default: false,
        },
        /** Задержка показать/скрыть, объект вида { show: 500, hide: 100 } */
        delay: {
            type: [String, Number, Object],
            default: () => ({
                show: 200,
                hide: 0,
            }),
        },
        /** Заблокированный */
        disabled: {
            type: Boolean,
            default: false,
        },
        /** Контейнер, в который будет добавляться разметка контента */
        container: {
            type: null,
            validator: (value) => value === null || value instanceof Element || typeof value === 'string',
            default: null,
        },
        /** Максимальная ширина всплывающей подсказки */
        maxWidth: {
            type: [Number, String],
            default: null,
        },
        /** Минимальная высота всплывающей подсказки */
        minHeight: {
            type: [Number, String],
            default: null,
        },
        /** Определяет смещение всплывающей подсказки от целевого элемента в px */
        offset: {
            type: [Number, String],
            default: 8,
        },
        /** Классы для контейнера всплывающей подсказки */
        popperClass: {
            type: String,
            default: '',
        },
        /** Набор свойств плавающего элемента. See @omnica/popper-vue3 */
        popperOptions: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: [
        /** Смена видимости всплывающей подсказки */
        'toggle',
        /** Смена видимости всплывающей подсказки */
        'update:opened',
    ],
    setup(__props, { emit }) {
        const props = __props;
        const emitToggle = (opened) => {
            emit('toggle', opened);
            emit('update:opened', opened);
        };
        const shown = ref(props.opened);
        watch(() => props.opened, v => shown.value = v);
        const target = ref(null);
        let hideTimeout = undefined;
        const show = () => {
            if (props.trigger === 'manual') {
                return;
            }
            shown.value = true;
            emitToggle(true);
            const hideTime = parseInt(props.hideTime, 10) || 0;
            if (hideTime) {
                clearTimeout(hideTimeout);
                hideTimeout = setTimeout(hide, hideTimeout);
            }
        };
        const hide = () => {
            clearTimeout(hideTimeout);
            hideTimeout = undefined;
            shown.value = false;
        };
        const toPx = (value) => value ? `${parseInt(String(value))}px` : 'none';
        const onContentClick = (event) => {
            const el = event.target;
            if (el.closest('[data-close-tooltip]')) {
                shown.value = false;
                emitToggle(false);
            }
        };
        onBeforeUnmount(hide);
        return (_ctx, _cache) => {
            return (openBlock(), createElementBlock("div", _hoisted_1, [
                createElementVNode("div", {
                    ref_key: "target",
                    ref: target,
                    class: "omnica-tooltip__trigger",
                    onClick: show
                }, [
                    createCommentVNode(" @slot Элемент, на котором показывается тултип "),
                    renderSlot(_ctx.$slots, "trigger")
                ], 512 /* NEED_PATCH */),
                createVNode(unref(UiPopper), mergeProps({
                    shown: shown.value,
                    "onUpdate:shown": _cache[1] || (_cache[1] = ($event) => ((shown).value = $event)),
                    target: () => _ctx.$refs.target,
                    triggers: __props.closable || !!__props.hideTime ? [] : [__props.trigger],
                    placement: __props.placement,
                    delay: __props.delay,
                    "offset-main-axis": __props.offset,
                    container: __props.container,
                    "auto-hide": __props.trigger !== 'manual' && !__props.hideTime && !__props.closable,
                    class: {
                        'omnica-tooltip__popper': true,
                        'omnica-tooltip__popper_centered': __props.centered,
                        'omnica-tooltip__popper_closable': __props.closable,
                        'omnica-tooltip__popper_inline': __props.inline,
                        'omnica-tooltip__popper_large': __props.large,
                        'omnica-tooltip__popper_pointer': __props.withPointer || __props.closable,
                        'omnica-tooltip__popper_with-steps': _ctx.$slots.steps && !_ctx.$slots.title,
                        [__props.popperClass]: !!__props.popperClass,
                    },
                    dark: __props.dark,
                    "with-arrow": __props.withPointer || __props.closable,
                    disabled: __props.disabled
                }, __props.popperOptions, {
                    onHide: _cache[2] || (_cache[2] = ($event) => (emitToggle(false)))
                }), {
                    default: withCtx(() => [
                        createElementVNode("div", {
                            style: normalizeStyle({
                                maxWidth: toPx(props.maxWidth),
                                minHeight: toPx(props.minHeight),
                            }),
                            class: "omnica-tooltip__content",
                            onClick: onContentClick
                        }, [
                            (__props.closable)
                                ? (openBlock(), createElementBlock("div", {
                                    key: 0,
                                    class: "omnica-tooltip__close",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (shown.value = false))
                                }, [
                                    createVNode(unref(render))
                                ]))
                                : (_ctx.$slots.steps)
                                    ? (openBlock(), createElementBlock("div", _hoisted_2, [
                                        createCommentVNode(" @slot Текст-подсказка справа от заголовка "),
                                        renderSlot(_ctx.$slots, "steps")
                                    ]))
                                    : createCommentVNode("v-if", true),
                            (_ctx.$slots.title)
                                ? (openBlock(), createElementBlock("div", {
                                    key: 2,
                                    class: normalizeClass({
                                        'omnica-tooltip__title': true,
                                        'omnica-tooltip__title_with-steps': _ctx.$slots.steps,
                                    })
                                }, [
                                    createCommentVNode(" @slot Заголовок "),
                                    renderSlot(_ctx.$slots, "title")
                                ], 2 /* CLASS */))
                                : createCommentVNode("v-if", true),
                            createCommentVNode(" @slot Разметка тултипа "),
                            renderSlot(_ctx.$slots, "default"),
                            (_ctx.$slots.footer && __props.large)
                                ? (openBlock(), createElementBlock("div", _hoisted_3, [
                                    createCommentVNode(" @slot Разметка подвала "),
                                    renderSlot(_ctx.$slots, "footer")
                                ]))
                                : createCommentVNode("v-if", true)
                        ], 4 /* STYLE */)
                    ]),
                    _: 3 /* FORWARDED */
                }, 16 /* FULL_PROPS */, ["shown", "target", "triggers", "placement", "delay", "offset-main-axis", "container", "auto-hide", "class", "dark", "with-arrow", "disabled"])
            ]));
        };
    }
});

script.__file = "packages/tooltip/src/UiTooltip.vue";

var index = {
    install(app) {
        app.directive('tooltip', vTooltip);
        app.component('UiTooltip', script);
    },
};

export { script as UiTooltip, index as default, vTooltip };
